var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.container},[_c('div',{class:_vm.$style.empty,domProps:{"textContent":_vm._s(_vm.$t('crypto.payment.transaction.empty'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }